import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'

export function useIsCreatedByCurrentUser(createdById: string) {
	const { data: currentUser } = useQueryProfile()
	return currentUser?.id === createdById
}
